jQuery(($) => {

  if($('.m-gallery-carousel__featured')[0]){

    $('.m-gallery-carousel__featured-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      asNavFor: $('.m-gallery-carousel__navigation-list'),
    });

    $('.m-gallery-carousel__navigation-list').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      asNavFor: $('.m-gallery-carousel__featured-list'),
      focusOnSelect: true,
    });
  }

});